import React from "react";
import { Navigate, useNavigate } from "react-router";
import { useAuth } from "contexts/AuthProvider";
import { AuthHeader } from "@/components/authentication/common/AuthHeader";
import { ConsentForm } from "./ConsentForm";
import { hasUpdatedTerms } from "./legalContent";

export const ConsentPage = () => {
  const navigate = useNavigate();
  const { authenticated, loading, tosAccepted, ppAccepted } = useAuth();

  if (loading) {
    return <div></div>;
  }

  if (!authenticated) {
    return <Navigate to="/" />;
  }

  if (tosAccepted && ppAccepted) {
    return <Navigate to="/overview" />;
  }

  return (
    <section className="auth-page">
      <div className="flex flex-col justify-center items-center min-h-full px-6 py-12 lg:px-8">
        <div className="w-full sm:max-w-sm flex flex-col gap-8">
          <AuthHeader
            title={hasUpdatedTerms ? "Updated Terms" : "Terms of Service"}
            message={
              hasUpdatedTerms
                ? "We've updated our terms. Please review the changes."
                : "Please review and accept to continue"
            }
          />
          <ConsentForm onAccepted={() => navigate("/overview")} />
        </div>
      </div>
    </section>
  );
};
